import CrudRequest from 'Domain/CrudRequest';
import HttpService from 'Support/services/HttpService';

export default class TaxGroupRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/grupoControleDeTaxas';
  }

  static get(id) {
    return HttpService.get(
      `${this.baseUrl()}/consultarPorId`,
      {
        params: {
          id,
        },
      },
    );
  }

  static listClients(id) {
    return HttpService.get(
      `${this.baseUrl()}/consultarClientesDoGrupo`,
      {
        params: {
          grupoId: id,
        },
      },
    );
  }

  static saveClients(id, payload) {
    return HttpService.put(
      `${this.baseUrl()}/${id}/clientes`,
      payload,
    );
  }
}
